export default function Step5() {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M28.882 25.366L32.4258 21.64C33.1805 20.8461 34.4319 20.8177 35.2221 21.5759C36.0115 22.3332 36.0406 23.5913 35.2859 24.3843L27.4027 32.8527C26.3983 33.9314 24.9372 34.4579 23.4788 34.2647L11.0273 32.6165"
                stroke="#85A3FF"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.8823 25.3668L30.9331 23.2121C31.6869 22.4191 31.6586 21.1619 30.8684 20.4037C30.0791 19.6455 28.8267 19.6748 28.0729 20.4678L24.6504 24.072"
                stroke="#85A3FF"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2503 28.0902H27.0454C28.1373 28.0902 29.0233 27.2011 29.0233 26.1031C29.0233 25.0061 28.1373 24.117 27.0454 24.117L21.2503 24.1014L18.814 22.8423C17.0795 21.9468 15.0332 21.8964 13.2577 22.7059L11.0273 23.7232"
                stroke="#85A3FF"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.116 34.5704H7.57846C7.07533 34.5704 6.66699 34.161 6.66699 33.6547V22.3376C6.66699 21.8312 7.07533 21.4219 7.57846 21.4219H10.116C10.6191 21.4219 11.0274 21.8312 11.0274 22.3376V33.6547C11.0274 34.161 10.6191 34.5704 10.116 34.5704Z"
                stroke="#85A3FF"
                strokeWidth="1.71429"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="20.833" cy="12.5" r="7.5" stroke="#85A3FF" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M20.3665 8.42569V7.84569H20.8865V8.42569C22.2865 8.52569 23.7365 9.04569 23.9265 10.5957H22.3065V10.5857C22.2565 10.1157 21.7565 9.65569 20.8865 9.54569V11.3657H20.8965C22.4465 11.5257 24.1665 11.7657 24.1665 13.4357C24.1665 15.1157 22.4365 15.6357 20.8865 15.6657V16.6657H20.3665V15.6657C18.6465 15.5857 17.1465 15.0157 17.1065 13.2457H18.7265C18.7865 14.1557 19.4865 14.5057 20.3665 14.6057V12.5457C18.8765 12.3557 17.2865 12.1257 17.2865 10.5357C17.2865 9.07569 18.6065 8.45569 20.3665 8.42569ZM20.3665 9.54569C19.9965 9.55569 18.8465 9.63569 18.8465 10.4657C18.8465 11.0257 19.4665 11.2057 20.3665 11.3357V9.54569ZM20.8865 12.6557V14.6057C21.7865 14.5757 22.5465 14.3057 22.5465 13.6157C22.5465 12.9857 21.8365 12.7857 20.8865 12.6557Z"
                fill="#8AA7FF"
            />
        </svg>
    );
}
